var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#E5E2EB",
    cx: 65,
    cy: 65,
    r: 65
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.404 34.6c0-7.815-6.242-14.15-13.942-14.15H48.999c-7.7 0-13.943 6.335-13.943 14.15V96.86c0 7.815 6.243 14.15 13.943 14.15h33.463c7.7 0 13.942-6.335 13.942-14.15V34.6zm-13.942-8.49c4.62 0 8.365 3.8 8.365 8.49V96.86c0 4.69-3.745 8.49-8.365 8.49H48.999c-4.62 0-8.366-3.8-8.366-8.49V34.6c0-4.69 3.746-8.49 8.366-8.49h33.463z",
    fill: "#2F224A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.902 67.35a2.862 2.862 0 0 1 0-3.729l6.693-7.753a2.76 2.76 0 0 1 3.935-.263 2.86 2.86 0 0 1 .26 3.994l-5.083 5.887 5.083 5.888a2.859 2.859 0 0 1-.26 3.993 2.76 2.76 0 0 1-3.935-.263l-6.693-7.753z",
    fill: "#E7426B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.242 51.789c1.435.566 2.129 2.2 1.549 3.648l-9.07 22.64c-.58 1.449-2.213 2.163-3.649 1.596-1.435-.567-2.128-2.2-1.548-3.648l9.07-22.64c.58-1.448 2.213-2.162 3.648-1.595v-.001z",
    fill: "#2F224A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.866 75.103 6.693-7.752a2.862 2.862 0 0 0 0-3.73l-6.693-7.752a2.76 2.76 0 0 0-3.935-.264 2.86 2.86 0 0 0-.26 3.993l5.083 5.888-5.083 5.888a2.859 2.859 0 0 0 .26 3.993 2.76 2.76 0 0 0 3.935-.264z",
    fill: "#E7426B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.153 31.77c-1.54 0-2.788 1.267-2.788 2.83 0 1.563 1.248 2.83 2.788 2.83h11.154c1.54 0 2.789-1.267 2.789-2.83 0-1.563-1.249-2.83-2.789-2.83H60.153z",
    fill: "#2F224A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.22d07dcd36dfecfdeafecf004920f97f.svg";
export { ForwardRef as ReactComponent };